import PublicShell from "@/components/PublicShell";
import { site } from "@/lib/api";
import { useAsync } from "@/lib/hooks";

import { Section } from "./Privacy";

const UPDATED = "9 September 2026";

export default function Terms() {
  const info = useAsync(() => site.info().catch(() => null), []);

  return (
    <PublicShell contactEmail={info.data?.contact_email}>
      <article className="max-w-2xl">
        <p className="unit">Terms of use · updated {UPDATED}</p>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight">The terms, briefly</h1>

        <Section title="What this is">
          Pool Nerd is a logbook and calculator for pool and hot tub water chemistry. It is
          provided as-is, free of charge, by one person, with no promise that it will be available
          at any particular time or that it will keep existing.
        </Section>

        <Section title="It is advice, not authority">
          Dose amounts are computed from published pool chemistry references and the volume and
          product strengths you enter. They are only as right as those inputs, and a pool is a
          body of water people swim in. Check the label on the product, never mix chemicals, add
          them to water rather than water to them, and if the app's answer looks wrong, trust
          your own judgement and a fresh test over the app. The assistant's answers are generated
          by a language model and can be mistaken.
        </Section>

        <Section title="Your account">
          Keep it to yourself. You are responsible for what is logged under it. Don't use the
          service to store anything you would not want stored, and don't try to reach data that
          is not yours — the service is built so that you cannot, and trying is a reason to
          close the account.
        </Section>

        <Section title="Your data is yours">
          You can delete your account and everything in it at any time from Settings. If the
          service ever shuts down, reasonable notice will be given so you can export what you
          need.
        </Section>

        <Section title="Liability">
          To the extent the law allows, the service is provided without warranty and its operator
          is not liable for any loss arising from its use, including damage to a pool, equipment
          or a person from a chemical addition.
        </Section>
      </article>
    </PublicShell>
  );
}
